/* Ineessance : ajout / retrait automatique des cadeaux par palier dans le panier (thème Prestige). */
(function () {
  if (window.__inesCartInit) return;
  window.__inesCartInit = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var busy = false;
  var pending = false;

  function readConfig() {
    var el = document.getElementById('ines-cart-config');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function isGift(item) {
    return item.properties && item.properties._ines_gift;
  }

  function post(url, body) {
    return fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }

  async function replaceDrawer() {
    var drawer = document.querySelector('cart-drawer');
    var wrap = document.querySelector('[id^="shopify-section-"][id$="cart-drawer"]');
    if (!drawer || !wrap) return;
    var id = wrap.id.replace('shopify-section-', '');
    var html = await fetch(root + '?section_id=' + encodeURIComponent(id)).then(function (r) { return r.text(); });
    var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-drawer');
    if (!fresh) return;
    drawer.className = fresh.className;
    drawer.replaceChildren.apply(drawer, Array.from(fresh.childNodes).map(function (n) { return document.importNode(n, true); }));
  }

  /* Calcule les cadeaux à ajouter / retirer pour un panier donné (lignes payantes, lignes cadeaux, total hors cadeaux) */
  function planGifts(config, paidLines, giftLines, total) {
    var updates = {};
    var adds = [];
    // Premier article personnalisé : son prénom et sa police servent aux cadeaux gravés
    var named = paidLines.find(function (i) { return i.properties && i.properties['Prénom']; });

    config.gifts.forEach(function (g) {
      var lines = giftLines.filter(function (l) { return l.properties._ines_gift === g.tier; });
      var eligible = paidLines.length > 0 && total >= g.threshold && g.variant_id && g.available;
      var keepKey = null;

      if (eligible) {
        var good = lines.find(function (l) { return l.variant_id === g.variant_id; });
        if (good) {
          keepKey = good.key;
          if (good.quantity !== 1) updates[good.key] = 1;
        } else {
          var props = { _ines_gift: g.tier };
          if (g.named && named) {
            props['Prénom'] = named.properties['Prénom'];
            if (named.properties['Choix police']) props['Choix police'] = named.properties['Choix police'];
          }
          adds.push({ id: g.variant_id, quantity: 1, properties: props });
        }
      }
      lines.forEach(function (l) { if (l.key !== keepKey) updates[l.key] = 0; });
    });

    // Cadeaux d'un palier qui n'existe plus dans la config
    giftLines.forEach(function (l) {
      var known = config.gifts.some(function (g) { return g.tier === l.properties._ines_gift; });
      if (!known) updates[l.key] = 0;
    });

    return { updates: updates, adds: adds };
  }

  function topTier(adds) {
    return adds.reduce(function (m, a) { return Number(a.properties._ines_gift) > Number(m) ? a.properties._ines_gift : m; }, '0');
  }

  async function sync() {
    var config = readConfig();
    if (!config) return;
    if (busy || lineBusy) { pending = true; return; }
    busy = true;

    try {
      var cart = await fetch(root + 'cart.js').then(function (r) { return r.json(); });
      var giftLines = cart.items.filter(isGift);
      var paidLines = cart.items.filter(function (i) { return !isGift(i); });
      var giftValue = giftLines.reduce(function (s, i) { return s + i.final_line_price; }, 0);
      var total = cart.total_price - giftValue;
      var plan = planGifts(config, paidLines, giftLines, total);
      var updates = plan.updates;
      var adds = plan.adds;

      var changed = false;
      if (Object.keys(updates).length) {
        await post('cart/update.js', { updates: updates });
        changed = true;
      }
      if (adds.length) {
        await post('cart/add.js', { items: adds });
        changed = true;
      }
      if (changed) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        // Prestige ne redessine pas le tiroir quand le panier devient vide via cart:refresh
        if (paidLines.length === 0) setTimeout(replaceDrawer, 400);
      }
      if (adds.length) {
        // Animation pour le cadeau le plus haut qui vient d'être débloqué
        var top = topTier(adds);
        setTimeout(function () { playGift(top); }, 500);
      }
    } catch (e) {
      console.warn('[ines-cart]', e);
    } finally {
      busy = false;
      if (pending) { pending = false; setTimeout(sync, 50); }
    }
  }

  document.addEventListener('cart:change', function () { setTimeout(sync, 50); });
  window.addEventListener('pageshow', function () { sync(); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }

  /* Tiroir panier : +, −, « Supprimer » et saisie de quantité gérés ici, en une seule fois.
     - l'article, ses options payantes Easify (lignes _tpo_add_on_key) et les cadeaux sont mis à jour ensemble ;
     - le tiroir est redessiné une seule fois et reste ouvert (pas de rechargement de page par Easify) ;
     - en cas d'échec : rechargement de la page, comme avant. */
  var lineBusy = false;

  function drawerSectionId() {
    var wrap = document.querySelector('[id^="shopify-section-"][id$="cart-drawer"]');
    return wrap ? wrap.id.replace('shopify-section-', '') : null;
  }

  function addOnKeys(item) {
    var raw = item.properties && item.properties._tpo_add_on_keys;
    if (!raw) return [];
    try { var k = JSON.parse(raw); return Array.isArray(k) ? k : []; } catch (e) { return []; }
  }

  async function changeLine(ref, qty, lineEl) {
    var config = readConfig();
    lineBusy = true;
    if (lineEl) lineEl.classList.add('ines-line-busy');
    try {
      var cart = await fetch(root + 'cart.js').then(function (r) { return r.json(); });
      var line = ref.key
        ? cart.items.find(function (i) { return i.key === ref.key; })
        : cart.items[ref.line - 1];
      if (!line) throw new Error('line');
      if (qty === null) qty = Math.max(0, line.quantity + (ref.delta || 0));
      if (qty === line.quantity) { lineBusy = false; if (lineEl) lineEl.classList.remove('ines-line-busy'); return; }

      var newQty = {};
      newQty[line.key] = qty;

      // Options payantes Easify rattachées à cet article : même proportion que l'article
      var keys = addOnKeys(line);
      if (keys.length) {
        cart.items.forEach(function (i) {
          var k = i.properties && i.properties._tpo_add_on_key;
          if (!k || keys.indexOf(k) === -1) return;
          newQty[i.key] = line.quantity > 0 ? Math.round(i.quantity / line.quantity * qty) : qty;
        });
      }

      // Panier tel qu'il sera après le changement, pour recalculer les cadeaux
      var projected = cart.items.map(function (i) {
        if (!(i.key in newQty)) return i;
        var q = newQty[i.key];
        return Object.assign({}, i, { quantity: q, final_line_price: i.final_price * q });
      }).filter(function (i) { return i.quantity > 0; });

      var updates = Object.assign({}, newQty);
      var adds = [];
      if (config) {
        var giftLines = projected.filter(isGift);
        var paidLines = projected.filter(function (i) { return !isGift(i); });
        // Même base que sync() (total du panier hors cadeaux), corrigée de l'écart des lignes modifiées
        var oldGiftValue = cart.items.filter(isGift).reduce(function (s, i) { return s + i.final_line_price; }, 0);
        var delta = cart.items.reduce(function (s, i) {
          if (!(i.key in newQty) || isGift(i)) return s;
          return s + i.final_price * (newQty[i.key] - i.quantity);
        }, 0);
        var total = cart.total_price - oldGiftValue + delta;
        var plan = planGifts(config, paidLines, giftLines, total);
        Object.keys(plan.updates).forEach(function (k) { if (!(k in updates)) updates[k] = plan.updates[k]; });
        adds = plan.adds;
      }

      if (adds.length) {
        var ra = await post('cart/add.js', { items: adds });
        if (!ra.ok) adds = [];
      }

      var sectionId = drawerSectionId();
      var body = { updates: updates };
      if (sectionId) body.sections = sectionId;
      var r = await post('cart/update.js', body);
      if (!r.ok) throw new Error('update');
      var result = await r.json();

      lineBusy = false;
      if (sectionId && result.sections && result.sections[sectionId]) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: { baseEvent: 'line-item:change', cart: result }
        }));
      } else {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        if (result.item_count === 0) setTimeout(replaceDrawer, 400);
      }
      if (adds.length) {
        var top = topTier(adds);
        setTimeout(function () { playGift(top); }, 500);
      }
    } catch (e) {
      console.warn('[ines-cart]', e);
      window.location.reload();
    } finally {
      lineBusy = false;
    }
  }

  function readRef(href) {
    try {
      var u = new URL(href, window.location.origin);
      if (!/\/cart\/change/.test(u.pathname)) return null;
      var q = parseInt(u.searchParams.get('quantity'), 10);
      if (isNaN(q) || q < 0) return null;
      var id = u.searchParams.get('id');
      var lineNo = parseInt(u.searchParams.get('line'), 10);
      if (id && id.indexOf(':') !== -1) return { key: id, qty: q };
      if (!isNaN(lineNo)) return { line: lineNo, qty: q };
      return null;
    } catch (e) { return null; }
  }

  /* Phase de capture sur window : passe avant le thème et avant Easify.
     Easify remplace le lien des boutons +/− par « ## » sur ses articles : on se repère donc
     à la structure du tiroir (bouton +/− ou lien « Supprimer ») et à la clé de ligne du champ quantité. */
  window.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('cart-drawer line-item-quantity a, cart-drawer line-item-quantity button');
    if (!el) return;
    var box = el.closest('line-item-quantity');
    var input = box && box.querySelector('input[data-line-key]');
    var ref = null;
    var sel = el.closest('quantity-selector');
    if (input && sel) {
      if (el.disabled || !el.classList.contains('quantity-selector__button')) return;
      var btns = sel.querySelectorAll('.quantity-selector__button');
      var step = parseInt(input.getAttribute('step'), 10) || 1;
      ref = { key: input.getAttribute('data-line-key'), delta: el === btns[0] ? -step : step };
    } else if (input && !sel) {
      ref = { key: input.getAttribute('data-line-key'), qty: 0 };
    } else {
      ref = el.getAttribute('href') ? readRef(el.getAttribute('href')) : null;
    }
    if (!ref) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (lineBusy) return;
    changeLine(ref, 'qty' in ref ? ref.qty : null, el.closest('line-item'));
  }, true);

  window.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.matches || !input.matches('cart-drawer input[data-line-key]')) return;
    var q = parseInt(input.value, 10);
    if (isNaN(q) || q < 0) return;
    e.stopImmediatePropagation();
    if (lineBusy) return;
    changeLine({ key: input.getAttribute('data-line-key') }, q, input.closest('line-item'));
  }, true);

  /* Cadeau débloqué : une cigogne (marron du logo) apporte le paquet sur la ligne cadeau. Léger : SVG + Web Animations, environ 2 s. */
  var STORK = '<svg viewBox="0 0 120 80" width="110" height="73" aria-hidden="true"><g stroke="#845c44" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">' +
    '<path d="M80 45l32 6M78 47l30 9" fill="none" stroke="#d98c5f" stroke-width="1.8"/>' +
    '<path d="M86 37l16-4-4 10z" fill="#845c44"/>' +
    '<path d="M40 40C44 31 70 29 90 37 80 48 54 51 40 40z" fill="#fff"/>' +
    '<path d="M45 36C37 34 33 26 27 24.5L24.5 31C31 32 36 41 46 42z" fill="#fff"/>' +
    '<circle cx="24" cy="28" r="5" fill="#fff"/><circle cx="22.4" cy="27" r=".9" fill="#845c44" stroke="none"/>' +
    '<path d="M19.5 27.5L2 33.5l17.5-2.5z" fill="#d98c5f" stroke="#d98c5f" stroke-width="1"/>' +
    '<g class="ines-stork__wing"><path d="M54 36C58 18 76 6 104 4 96 12 90 22 80 36z" fill="#fff"/><path d="M104 4C98 9 94 15 90.5 21.5L97 20.5C99.5 14 102 9 104 4z" fill="#845c44"/></g>' +
    '</g></svg>';
  var BUNDLE = '<svg viewBox="0 0 30 30" width="30" height="30" aria-hidden="true"><g stroke="#845c44" stroke-width="1.6" stroke-linejoin="round" stroke-linecap="round">' +
    '<path d="M15 5C6 11 3 20 6 26c4 3 14 3 18 0 3-6 0-15-9-21z" fill="#f5efe8"/>' +
    '<path d="M11 5L7 1M19 5l4-4" fill="none"/><ellipse cx="15" cy="5" rx="3.5" ry="2.5" fill="#d98c5f"/></g></svg>';
  (function () {
    var st = document.createElement('style');
    st.textContent = '.ines-stork,.ines-bundle{position:fixed;left:0;top:0;z-index:2147483000;pointer-events:none;will-change:transform}' +
      '.ines-stork__wing{transform-box:fill-box;transform-origin:5% 100%;animation:inesFlap .3s ease-in-out infinite alternate}' +
      '@keyframes inesFlap{from{transform:rotate(0)}to{transform:rotate(30deg) scaleY(.65)}}' +
      '.ines-gift-line.ines-pop{animation:inesPop 1.1s ease}' +
      '@keyframes inesPop{0%{transform:scale(1)}35%{transform:scale(1.03);background:rgba(255,255,255,.14)}100%{transform:scale(1);background:transparent}}' +
      '.ines-line-busy{opacity:.5;pointer-events:none;transition:opacity .15s}' +
      '.ines-sn__list.is-single{display:block}.ines-sn__c.is-wide{flex-direction:row;gap:12px;align-items:stretch}.ines-sn__c.is-wide .ines-sn__img{flex:0 0 38%}.ines-sn__c.is-wide .ines-sn__img img{height:100%}.ines-sn__body{display:flex;flex-direction:column;gap:6px;flex:1;min-width:0}.ines-sn__c.is-wide .ines-sn__b{right:auto;width:calc(38% - 20px)}';
    document.head.appendChild(st);
  })();
  var playing = false;
  function playGift(tier) {
    if (playing) return;
    var tries = 0;
    (function wait() {
      var d = document.querySelector('cart-drawer');
      var line = d && d.querySelector('.ines-gift-line[data-tier="' + tier + '"]');
      if (!d || !d.hasAttribute('open') || !line) { if (++tries < 30) setTimeout(wait, 200); return; }
      if (!document.body.animate || (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) { line.classList.add('ines-pop'); return; }
      fly(line);
    })();
  }
  function fly(line) {
    playing = true;
    try { line.scrollIntoView({ block: 'center' }); } catch (e) {}
    setTimeout(function () {
      var img = line.querySelector('img') || line;
      var r = img.getBoundingClientRect();
      var tx = r.left + r.width / 2, ty = r.top + r.height / 2;
      var s = document.createElement('div'); s.className = 'ines-stork'; s.innerHTML = STORK;
      var b = document.createElement('div'); b.className = 'ines-bundle'; b.innerHTML = BUNDLE;
      document.body.appendChild(s); document.body.appendChild(b);
      /* Le paquet pend sous le bec : décalage (-10, 30) par rapport à la cigogne */
      var mx = tx - 5, my = ty - 95;
      var sx = window.innerWidth + 30, sy = Math.max(-40, my - 140);
      var ex = tx - 300, ey = -130;
      function at(x, y) { return 'translate(' + x + 'px,' + y + 'px)'; }
      function bat(x, y, rot) { return 'translate(' + (x - 10) + 'px,' + (y + 30) + 'px) rotate(' + (rot || 0) + 'deg)'; }
      var ease = 'cubic-bezier(.22,.7,.3,1)';
      s.animate([{ transform: at(sx, sy) }, { transform: at(mx, my) }], { duration: 950, easing: ease, fill: 'forwards' });
      var a = b.animate([{ transform: bat(sx, sy, -10) }, { transform: bat(mx, my, 6) }], { duration: 950, easing: ease, fill: 'forwards' });
      a.onfinish = function () {
        var drop = b.animate([
          { transform: bat(mx, my, 6), opacity: 1 },
          { transform: 'translate(' + (tx - 15) + 'px,' + (ty - 15) + 'px) scale(.8)', opacity: 1, offset: .75 },
          { transform: 'translate(' + (tx - 15) + 'px,' + (ty - 15) + 'px) scale(.3)', opacity: 0 }
        ], { duration: 650, easing: 'cubic-bezier(.5,0,.75,0)', fill: 'forwards' });
        drop.onfinish = function () { b.remove(); line.classList.remove('ines-pop'); void line.offsetWidth; line.classList.add('ines-pop'); };
        var away = s.animate([{ transform: at(mx, my) }, { transform: at(ex, ey) }], { duration: 850, delay: 200, easing: 'cubic-bezier(.5,0,.8,.4)', fill: 'forwards' });
        away.onfinish = function () { s.remove(); playing = false; };
      };
      setTimeout(function () { if (s.parentNode) s.remove(); if (b.parentNode) b.remove(); playing = false; }, 4000);
    }, 260);
  }
  window.__inesPlayGift = playGift;

  /* Avec le même prénom : ajoute l'article avec le prénom, la police et les choix de la carte (fil, tissu, taille) */
  document.addEventListener('click', async function (e) {
    var b = e.target.closest && e.target.closest('.ines-sn__add');
    if (!b || b.disabled) return;
    e.preventDefault();
    var card = b.closest('.ines-sn__c');
    var v = card && card.querySelector('.ines-sn__v:not([data-prop])');
    if (!v || !v.value) return;
    var props = { 'Prénom': b.dataset.name, '_ines_upsell': 'meme-prenom' };
    if (b.dataset.font) props['Choix police'] = b.dataset.font;
    [].forEach.call(card.querySelectorAll('[data-prop]'), function (el) { if (el.value) props[el.dataset.prop] = el.value; });
    var label = b.innerHTML;
    b.disabled = true;
    b.textContent = 'Ajout…';
    try {
      var r = await post('cart/add.js', { items: [{ id: Number(v.value), quantity: 1, properties: props }] });
      if (!r.ok) throw new Error('add');
      b.textContent = 'Ajouté';
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      setTimeout(sync, 300);
    } catch (err) {
      b.disabled = false;
      b.innerHTML = label;
      b.textContent = 'Réessayer';
    }
  });

  /* Pied du tiroir : lien « J'ai un code promo » qui déplie le champ (gagne de la hauteur sur mobile) */
  var codeOpen = false;
  function codeLink() {
    var f = document.querySelector('cart-drawer .cart-drawer__footer');
    if (!f) return;
    var cd = f.querySelector('.cart-discount');
    if (!cd) return;
    if (codeOpen || f.querySelector('.discount-badge')) f.classList.add('ines-code-open');
    if (f.querySelector('.ines-code-btn')) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'link-faded-reverse ines-code-btn';
    b.textContent = "J'ai un code promo";
    var host = f.querySelector('.v-stack');
    if (host) { host.classList.add('ines-foot-links'); host.appendChild(b); }
    else f.insertBefore(b, cd);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.ines-code-btn');
    if (!b) return;
    e.preventDefault();
    var f = b.closest('form');
    codeOpen = !f.classList.contains('ines-code-open');
    f.classList.toggle('ines-code-open', codeOpen);
    var i = codeOpen && f.querySelector('.cart-discount input.input');
    if (i) i.focus();
  });
  function watch() {
    var d = document.querySelector('cart-drawer');
    if (!d) { setTimeout(watch, 500); return; }
    codeLink();
    new MutationObserver(codeLink).observe(d, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();

  /* Date limite de commande pour Noël (date réelle réglée dans l'éditeur de thème) */
  if (!customElements.get('ines-deadline')) {
    customElements.define('ines-deadline', class extends HTMLElement {
      connectedCallback() {
        var raw = this.getAttribute('data-date');
        if (!raw) return;
        var end = new Date(raw + 'T23:59:59');
        if (isNaN(end)) return;
        var today = new Date();
        today.setHours(0, 0, 0, 0);
        var days = Math.ceil((end - today) / 86400000);
        if (days < 0 || days > 30) return;

        var dateTxt = end.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long' });
        var extra = this.getAttribute('data-text') || 'pour une livraison avant Noël';
        var left = days === 0 ? "dernier jour" : (days === 1 ? 'plus que 1 jour' : 'plus que ' + days + ' jours');
        this.innerHTML = 'Commandez avant le <strong>' + dateTxt + '</strong> ' + extra + ' <span>(' + left + ')</span>';
        this.hidden = false;
      }
    });
  }
})();
